import React, { useEffect, useRef, useState } from "react";
import $ from "jquery";
import "jquery-sparkline";

interface SparklineChartProps {
    data: number[];
    color: string;
    type: string;
    maximum?: number;
    slowArrival?: number;
    fastArrival?: number;
    projectedGasTarget?: number[];
}

export const SparklineChart: React.FC<SparklineChartProps> = ({
    data,
    color,
    type,
    maximum,
    slowArrival,
    fastArrival
}) => {
    const chartRef = useRef<HTMLDivElement>(null);
    const [tooltip, setTooltip] = useState<{ x: number; y: number; value?: number } | null>(null);
    let rangeStart = 0, rangeEnd = 0;
    if (type === "arrivalVelocity" && slowArrival !== undefined && fastArrival !== undefined && maximum) {
        rangeStart = (slowArrival / maximum) * 100;
        rangeEnd = (fastArrival / maximum) * 100;
    }

    useEffect(() => {
        if (chartRef.current) {
            $(chartRef.current).sparkline(data, {
                type: "line",
                lineColor: color,
                fillColor: "",
                width: "140px",
                height: "30px",
                lineWidth: 1,
                chartRangeMin: type === "arrivalVelocity" ? 0 : undefined,
                chartRangeMax: type === "arrivalVelocity" ? maximum : undefined,
                spotRadius: 0, // Removes extra bullet points
                minSpotColor: "transparent", // Hides min point
                maxSpotColor: "transparent", // Hides max point
                spotColor: "transparent", // Hides last point
            });
        }
    }, [data, color, type, maximum]);

    const handleMouseMove = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        const rect = event.currentTarget.getBoundingClientRect();
        const offsetX = event.clientX - rect.left;
        const index = Math.round((offsetX / rect.width) * (data.length - 1));

        if (index >= 0 && index < data.length) {
            setTooltip({
                x: offsetX,
                y: event.clientY - rect.top - 10,
                value: data[index]
            });
        }
    };

    const handleMouseLeave = () => {
        setTooltip(null);
    };

    return (
        <div
            style={{
                position: "relative",
                width: 150,
                height: 50,
                marginTop: 10,
                borderRadius: "4px",
                padding: "5px",
            }}
        >
            {type === "arrivalVelocity" && (
                <div
                    style={{
                        position: "absolute",
                        left: 0,
                        top: `${100 - rangeEnd}%`,
                        height: `${rangeEnd - rangeStart}%`,
                        width: "100%",
                        backgroundColor: "#12B76A",
                        opacity: 0.1,
                        zIndex: 0,
                    }}
                />
            )}
            <div ref={chartRef} />
            <div
                style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    cursor: "pointer",
                    background: "transparent",
                }}
                onMouseMove={handleMouseMove}
                onMouseLeave={handleMouseLeave}
            />
            {tooltip && (
                <div
                    style={{
                        position: "absolute",
                        left: tooltip.x,
                        top: tooltip.y,
                        background: "rgba(19, 31, 46, 0.8)",
                        color: "white",
                        padding: "4px",
                        fontSize: "12px",
                        borderRadius: "4px",
                        pointerEvents: "none",
                        whiteSpace: "nowrap",
                    }}
                >
                    {tooltip.value}
                </div>
            )}
        </div>
    );
};
